class StickyAddToCart extends HTMLElement {
  modalEl = document.querySelector('#sticky-quick-buy-mobile')

  // get all main CTA, '.pdp-form_atc-button', '#pdp-form_atc-button-faux'
  mainCtas = document.querySelectorAll('.product-form__buttons .product-form__submit')
  footer = document.querySelector('#shopify-section-footer')
  mobileBreakpoint = 750

  constructor () {
    super()
    this.productForm = document.querySelector('#mainProductFormSelection')
    this.productFormButton = this.productForm.querySelector('.product-form__submit')
    this.notifyMe = false
    this.stickyAtcDrawer = document.querySelector('add-to-cart-drawer')
    this.syncWithProductForm()
    this.classList.remove('hidden')
    this.stickyAtcDrawer.classList.remove('hidden')
  }

  syncWithProductForm() {
    const stickyAtcButton = this.querySelector('.sticky-bar-button')
    const stickyAtcButtonSpan = stickyAtcButton.querySelector('span')
    const productFormButtonSpan = this.productFormButton.querySelector('span')
    this.notifyMe = productFormButtonSpan.innerText.toLowerCase().includes('email')

    const handAtcButtonObserver = () => {
      const buttonText = productFormButtonSpan.innerHTML
      stickyAtcButtonSpan.innerHTML = buttonText
      stickyAtcButton.dataset.soldOut = this.productFormButton.dataset.soldOut
      stickyAtcButton.dataset.notifyMe = this.productFormButton.dataset.notifyMe
      this.notifyMe = buttonText.toLowerCase().includes('email')
    }

    const atcButtonObserver = new MutationObserver(handAtcButtonObserver)
    atcButtonObserver.observe(this.productFormButton, { attributes: true, childList: true, subtree: true })
  }

  connectedCallback () {
    // observe Main CTA and Footer
    // loop through main CTA and observe each element
    this.mainCtas.forEach((cta) => {
      this.observeElement(cta)
    })
    this.observeElement(this.footer)

    // list to custom events, document.dispatchEvent(new Event("cart drawer:opened"));
    document.addEventListener('cart drawer:opened', () => {
      this.modalEl.modalHide()
    })

    // listen for click on sticky CTA
    this.addEventListener('click', (e) => this.ctaClickHandler(e))
  }

  observeElement (element) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // the main CTA is visible, hide the sticky CTA
          this.updateVisibility('hide')
        } else {
          // the main CTA is not visible, show the sticky CTA
          this.updateVisibility('show')
        }
      })
    })

    // observe Main CTA and Footer
    observer.observe(element)
  }

  isInView (element) {
    const rect = element.getBoundingClientRect()
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight)
    const windowWidth = (window.innerWidth || document.documentElement.clientWidth)
    const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0)
    const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0)
    return (vertInView && horInView)
  }

  updateVisibility (action) {
    if (window.innerWidth >= this.mobileBreakpoint) {
      this.classList.remove('isVisible')
      document.body.classList.remove('sticky-cta-is-visible')
      return
    }

    // check if the main CTAs is in window viewport
    // Stops a bug when the window is opened when the main cta is visible, on close it would show the sticky cta too
    const mainCta = document.querySelector('.product-form__buttons .product-form__submit')
    const liveChatButton = document.querySelector('.chat-widget')
    if (this.isInView(mainCta)) {
      action = 'hide'
    }

    if (action === 'show') {
      // show sticky CTA
      this.classList.add('isVisible')
      // Added the one to the document element to improve the gender toggle, sit above the sticky CTA
      document.body.classList.add('sticky-cta-is-visible')
      liveChatButton.classList.add('sticky-cta-present')
    } else {
      // hide sticky CTA
      this.classList.remove('isVisible')
      document.body.classList.remove('sticky-cta-is-visible')
      liveChatButton.classList.remove('sticky-cta-present')
    }
  }

  openNotifyMe () {
    document.querySelector('#notify-me.modal').classList.remove('hide')
    document.body.classList.add('is-modal-open')
  }

  ctaClickHandler (e) {
    e.preventDefault()

    if (this.notifyMe) {
      this.openNotifyMe()
      return
    }

    // Below is legacy code needs to be improved.
    const formWrapper = document.querySelector('.main-product__form')
    const cartDrawer = document.querySelector('add-to-cart-drawer')
    const cartDrawerInner = document.querySelector('.sticky-bar--add-to-cart')
    const productForm = document.querySelector('.main-product__form-content')
    const body = document.body

    cartDrawer.classList.add('active')
    body.classList.add('overflow-hidden')
    cartDrawerInner.append(productForm)

    const submitButton = document.querySelector('add-to-cart-drawer .product-form__submit')
    const closeButton = document.querySelector('add-to-cart-drawer .sticky-bar__drawer-close')
    const outsideClickClose = document.querySelector('add-to-cart-drawer .sticky-bar__overlay')

    submitButton.addEventListener('click', () => {
      stickyATCClose()
    })

    closeButton.addEventListener('click', () => {
      stickyATCClose()
    })

    outsideClickClose.addEventListener('click', () => {
      stickyATCClose()
    })

    function stickyATCClose () {
      cartDrawer.classList.remove('active')
      formWrapper.append(productForm)
      body.classList.remove('overflow-hidden')
    }
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart)
